import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Evento, RegisterEvent } from '../models/evento';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'event/';
  }

  save(data: RegisterEvent): Observable<Evento> {
    let urlcom = this.url + "register/";
    return this.http.post<Evento>(urlcom, data);
  }

  // update evento
  update(data: RegisterEvent): Observable<Evento> {
    let urlcom = this.url + data.id;
    return this.http.put<Evento>(urlcom, data);
  }

  getById(id: number): Observable<Evento> {
    let urlcom = this.url + id;
    return this.http.get<Evento>(urlcom);
  }
}
